import { useState } from "react";
import { motion } from "framer-motion";
import { TABS } from "@/data";

export default function Header({ active, onSelect }) {
  const [glint, setGlint] = useState(0);
  return (
    <header data-testid="site-header" className="pt-6 sm:pt-10 pb-10 sm:pb-14 px-4 flex flex-col items-center">
      <button onClick={() => onSelect(null)} onMouseEnter={() => setGlint((g) => g + 1)} data-testid="header-logo" aria-label="Home" className="block">
        <span key={`${active}-${glint}`} className="glint-wrap" style={{ "--glint-mask": "url(/assets/xovasco-mask.png)" }}>
          <img src="/assets/xovasco-logo.png" alt="XO Vasco" className="w-[220px] sm:w-[300px] select-none" />
          <span className="glint" data-testid="logo-glint" />
        </span>
      </button>
      <nav className="mt-6 sm:mt-10 w-full max-w-xl flex justify-between sm:justify-center sm:gap-14">
        {TABS.map((t) => (
          <button key={t} onClick={() => onSelect(t)} data-testid={`nav-${t.toLowerCase()}`}
            className={`relative pb-2 text-xl sm:text-2xl tracking-[0.08em] font-light transition-colors duration-300 ${active === t ? "text-[#dcdfe4]" : "text-[#9a9ea6] hover:text-[#dcdfe4]"}`}>
            {t}
            {active === t && (
              <motion.span layoutId="nav-underline" className="absolute left-0 right-0 -bottom-1 h-[3px] bg-white" transition={{ type: "spring", stiffness: 420, damping: 36 }} />
            )}
          </button>
        ))}
      </nav>
    </header>
  );
}
